import AdminViewer from './AdminViewer';

export default AdminViewer;
